/**
 * Composable for standardized client-side tracking events
 */
export const useAnalytics = () => {
  const { $posthog } = useNuxtApp() as any
  const config = useRuntimeConfig()
  
  // Helper to ensure we get the latest release version on client
  const getReleaseVersion = () => config.public.gitSha || 'dev'

  return {
    track: (eventName: string, properties?: Record<string, any>) => {
      if ($posthog) {
        $posthog().capture(eventName, {
          ...properties,
          release_version: getReleaseVersion()
        } as any)
      } else if (process.env.NODE_ENV === 'development') {
        // Fallback logging for local dev if PostHog isn't configured
        console.log(`[Analytics Track] ${eventName}`, {
          ...properties,
          release_version: getReleaseVersion()
        })
      }
    },
    
    identify: (distinctId: string, properties?: Record<string, any>) => {
      if ($posthog) {
        $posthog().identify(distinctId, properties as any)
      } else if (process.env.NODE_ENV === 'development') {
        console.log(`[Analytics Identify] ${distinctId}`, properties)
      }
    },
    
    reset: () => {
      if ($posthog) {
        $posthog().reset()
      }
    }
  }
}
